(() => {
  // utils/common.js
  function poll(condition, callback, persistent = false, timeout = 1e4, pollInterval = 25) {
    if (condition()) {
      callback(condition());
    } else if (timeout > 0) {
      setTimeout(() => {
        poll(condition, callback, persistent, persistent ? timeout : timeout - pollInterval, pollInterval);
      }, pollInterval);
    }
  }
  function q(s, o) {
    return o ? s.querySelector(o) : document.querySelector(s);
  }
  function qq(s, o) {
    return o ? [...s.querySelectorAll(o)] : [...document.querySelectorAll(s)];
  }
  function insert(target, position, element, exists) {
    try {
      if (!exists) {
        typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
      }
    } catch (e) {
      console.debug(position, " :: ", element);
    }
  }

  // src/Wunschgutschein/WUN-25/1/info.js
  var ID = "WUN-25";
  var VAR = "1";
  function expLog() {
    window.runningExperiments[ID].logs.push([...arguments]);
  }

  // src/Wunschgutschein/WUN-25/1/index.js
  function testInfo(testName) {
    window.runningExperiments = window.runningExperiments || {};
    window.runningExperiments[ID] = {
      name: testName || "",
      variation: `${VAR}`,
      logs: []
    };
    poll(
      () => q("body"),
      () => {
        q("body").classList.add(`${ID}`, `${ID}_${VAR}`);
      }
    );
  }

  var selectors = {
    productQuantity: ".product-form__input.product-form__quantity",
    productForm: "product-form form"
  };

  // Detect language from URL path
  function detectLanguage() {
    const pathname = window.location.pathname;
    if (pathname.includes('/en/') || pathname.includes('/en?')) return 'en';
    if (pathname.includes('/nl/') || pathname.includes('/nl?')) return 'nl';
    return 'fr'; // default ke Deutsch
  }

  const currentLanguage = detectLanguage();

  var languageTexts = {
    en: {
      giftCardByMail: "Gift card by mail",
      shippingDays: "3-5 days",
      pdfByEmail: "PDF by email",
      instantly: "Instanly",
      shippingMethod: "Shipping method",
      tooltipText: "You can receive your gift card as a PDF 📄✨ or by mail 💌. The PDF is designed so you can easily fold it - just like a printed gift card. This way you have your gift card immediately, without any waiting time."
    },
    fr: {
      giftCardByMail: "Distribution postale",
      shippingDays: "3-5 jours",
      pdfByEmail: "Réception par email",
      instantly: "Directement",
      shippingMethod: "Mode d'expédition",
      tooltipText: "Vous pouvez recevoir la carte cadeau de votre choix au format <strong>PDF</strong> 📄✨ ou par <strong>courrier postal</strong> 💌. Le PDF est conçu de manière à pouvoir être facilement plié, tout comme la carte cadeau imprimée. Vous disposez ainsi immédiatement de votre carte cadeau, sans délai d'attente."
    },
    nl: {
      giftCardByMail: "Kaart per post",
      shippingDays: "2-3 werkdagen levertijd",
      pdfByEmail: "PDF per e-mail",
      instantly: "Direct",
      shippingMethod: "Verzendmethode",
      tooltipText: "Je kunt je cadeaubon naar wens ontvangen als PDF 📄✨ of per post 💌. De PDF is zo ontworpen dat je deze eenvoudig kunt vouwen – net als de gedrukte cadeaubon. Zo heb je je cadeaubon direct, zonder wachttijd."
    }
  };

  function getTextAsset(key) {
    return languageTexts[currentLanguage][key] || languageTexts.de[key];
  }

  var textAssets = {
    noProductsInCart: getTextAsset('tooltipText'),
    PDF: getTextAsset('tooltipText'),
    Karte: getTextAsset('tooltipText')
  };

  var infoIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.53793 12.788V8.28001H10.4619V12.788H9.53793ZM9.99993 7.63601C9.81327 7.63601 9.67327 7.58934 9.57993 7.49601C9.4866 7.40268 9.43993 7.26734 9.43993 7.09001C9.43993 6.90334 9.4866 6.76801 9.57993 6.68401C9.67327 6.59068 9.81327 6.54401 9.99993 6.54401C10.1493 6.54401 10.2753 6.59068 10.3779 6.68401C10.4899 6.76801 10.5459 6.90334 10.5459 7.09001C10.5459 7.27668 10.4899 7.41668 10.3779 7.51001C10.2753 7.59401 10.1493 7.63601 9.99993 7.63601ZM9.99993 15.77C9.2066 15.77 8.45993 15.6207 7.75993 15.322C7.05993 15.0233 6.44393 14.6127 5.91193 14.09C5.38927 13.558 4.9786 12.942 4.67993 12.242C4.38127 11.542 4.23193 10.7953 4.23193 10.002C4.23193 9.19934 4.38127 8.45268 4.67993 7.76201C4.9786 7.06201 5.38927 6.45068 5.91193 5.92801C6.44393 5.39601 7.05993 4.98068 7.75993 4.68201C8.45993 4.38334 9.2066 4.23401 9.99993 4.23401C10.8026 4.23401 11.5493 4.38334 12.2399 4.68201C12.9399 4.98068 13.5513 5.39601 14.0739 5.92801C14.6059 6.45068 15.0213 7.06201 15.3199 7.76201C15.6186 8.45268 15.7679 9.19934 15.7679 10.002C15.7679 10.7953 15.6186 11.542 15.3199 12.242C15.0213 12.942 14.6059 13.558 14.0739 14.09C13.5513 14.6127 12.9399 15.0233 12.2399 15.322C11.5493 15.6207 10.8026 15.77 9.99993 15.77ZM9.99993 14.986C10.6906 14.986 11.3346 14.86 11.9319 14.608C12.5386 14.3467 13.0706 13.9873 13.5279 13.53C13.9853 13.0727 14.3399 12.5453 14.5919 11.948C14.8533 11.3413 14.9839 10.6927 14.9839 10.002C14.9839 9.31134 14.8533 8.66734 14.5919 8.07001C14.3399 7.46334 13.9853 6.93134 13.5279 6.47401C13.0706 6.01668 12.5386 5.66201 11.9319 5.41001C11.3346 5.14868 10.6906 5.01801 9.99993 5.01801C9.30927 5.01801 8.6606 5.14868 8.05393 5.41001C7.4566 5.66201 6.92927 6.01668 6.47193 6.47401C6.0146 6.93134 5.65527 7.46334 5.39393 8.07001C5.14193 8.66734 5.01593 9.31134 5.01593 10.002C5.01593 10.6927 5.14193 11.3413 5.39393 11.948C5.65527 12.5453 6.0146 13.0727 6.47193 13.53C6.92927 13.9873 7.4566 14.3467 8.05393 14.608C8.6606 14.86 9.30927 14.986 9.99993 14.986Z" fill="#2E2A39" fill-opacity="0.75"/>
</svg>`;

  
  function injectTooltipStyles() {
    const styleId = `${ID}__tooltip-styles`;
    if (document.getElementById(styleId)) return;
    
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .${ID}__tooltip-container {
        position: relative;
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        margin-left: 6px;
      }
      
      .${ID}__tooltip-popup {
        display: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: calc(100% + 8px);
        background: #2E2A39;
        color: white;
        padding: 10px 12px;
        border-radius: 8px;
        font-size: 12px;
        line-height: 1.5;
        width: 240px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 1000;
        text-align: left;
      }
      
      .${ID}__tooltip-popup::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 6px solid transparent;
        border-top-color: #2E2A39;
      }
      
      .${ID}__tooltip-container:hover .${ID}__tooltip-popup {
        display: block;
      }
      
      .${ID}__tooltip-popup strong {
        font-weight: 600;
      }

      /* DEFAULT: Hide shipping options container */
      .${ID}__shipping-options-container {
        display: none !important;
      }

      /* Show when has-metafield class is added */
      .${ID}__shipping-options-container.has-metafield {
        display: block !important;
      }
    `;
    document.head.appendChild(style);
  }

  // ======================================
  // Check if product has metafield
  // ======================================
  function checkProductMetafield() {
    console.log("[WUN-25] Checking for metafield...");
    
    // Method 1: Check window.Shopify.product
    if (window.Shopify && window.Shopify.product) {
      const metafields = window.Shopify.product.metafields;
      if (metafields) {
        const hasMetafield = 
          metafields['custom.giftcard_second_product'] || 
          metafields['giftcard_second_product'] ||
          (metafields.custom && (metafields.custom.giftcard_second_product || metafields.custom['giftcard_second_product']));
        
        if (hasMetafield) {
          console.log("[WUN-25] Found metafield via window.Shopify.product");
          return true;
        }
      }
    }

    // Method 2: Check data attribute on product form
    const productForm = q(selectors.productForm);
    if (productForm) {
      const hasMetafield = 
        productForm.getAttribute('data-giftcard-second-product') ||
        productForm.getAttribute('data-custom-giftcard-second-product');
      
      if (hasMetafield) {
        console.log("[WUN-25] Found metafield via data attribute");
        return true;
      }
    }

    // Method 3: Check JSON-LD structured data
    const jsonLd = q('script[type="application/ld+json"]');
    if (jsonLd) {
      try {
        const data = JSON.parse(jsonLd.textContent);
        if (data && data.offers && data.offers[0]) {
          // Metafield might be in structured data
          const hasMetafield = 
            data.offers[0]['custom:giftcard_second_product'] ||
            data.offers[0]['giftcard_second_product'];
          
          if (hasMetafield) {
            console.log("[WUN-25] Found metafield via JSON-LD");
            return true;
          }
        }
      } catch (e) {
        console.debug("[WUN-25] Error parsing JSON-LD:", e);
      }
    }

    // Method 4: Check if there's a hidden input with metafield value
    const metafieldInput = q(`input[name*="giftcard_second_product"]`);
    if (metafieldInput && metafieldInput.value) {
      console.log("[WUN-25] Found metafield via input element");
      return true;
    }

    console.log("[WUN-25] No metafield found");
    return false;
  }

  // ======================================
  // Show/Hide shipping options based on metafield
  // ======================================
  function initializeShippingOptionsVisibility() {
    poll(
      () => q(`.${ID}__shipping-options-container`),
      () => {
        const container = q(`.${ID}__shipping-options-container`);
        const hasMetafield = checkProductMetafield();

        if (hasMetafield) {
          console.log("[WUN-25] Adding has-metafield class");
          container.classList.add("has-metafield");
        } else {
          console.log("[WUN-25] No metafield found, keeping container hidden");
          // Container stays hidden by default CSS
        }
      },
      false,
      5000
    );
  }

  // Function to determine current product type and get URLs
  function getCurrentProductInfo() {
    const currentUrl = window.location.pathname;
    let isCurrentPDF = false;
    let originalProductUrl = null;
    let pdfProductUrl = null;

    console.log("[WUN-25] Current URL:", currentUrl);
    
    // Extract language prefix if present
    let languagePrefix = '';
    if (currentUrl.includes('/en/')) {
      languagePrefix = '/en';
    } else if (currentUrl.includes('/nl/')) {
      languagePrefix = '/nl';
    }
    // French (default) has no prefix

    const currentHandle = currentUrl.split('/products/')[1]?.split('?')[0];
    if (!currentHandle) {
      console.error("[WUN-25] Could not extract handle from URL");
      return { isCurrentPDF, originalProductUrl, pdfProductUrl, currentHandle: '', productTitle: '' };
    }
    
    console.log("[WUN-25] Current handle:", currentHandle);
    console.log("[WUN-25] Language prefix:", languagePrefix || 'none (Deutsch)');
    
    // Detect if current is PDF based on handle
    const isPdfProduct = currentHandle && (
      currentHandle.toLowerCase().includes('-pdf-') ||
      currentHandle.toLowerCase().includes('_pdf_') ||
      currentHandle.toLowerCase().includes('-pdf') || 
      currentHandle.toLowerCase().includes('_pdf')
    );
    
    let productTitle = '';
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      productTitle = window.ShopifyAnalytics.meta.product.title || '';
    } else if (document.querySelector('h1.product__title, .product-title, h1')) {
      productTitle = document.querySelector('h1.product__title, .product-title, h1').textContent.trim();
    }
    
    console.log("[WUN-25] Product title:", productTitle);
    
    const isPdfByTitle = productTitle.toLowerCase().includes(' pdf');
    isCurrentPDF = isPdfProduct || isPdfByTitle;
    
    console.log("[WUN-25] Is current product PDF?", isCurrentPDF);
    
    // Method 1: Use naming convention (most reliable)
    if (isCurrentPDF) {
      // Current is PDF, generate original URL by removing PDF
      pdfProductUrl = currentUrl;
      
      if (currentHandle.endsWith('-pdf')) {
        originalProductUrl = `${languagePrefix}/products/${currentHandle.replace(/-pdf$/, '')}`;
      } else if (currentHandle.endsWith('_pdf')) {
        originalProductUrl = `${languagePrefix}/products/${currentHandle.replace(/_pdf$/, '')}`;
      } else if (currentHandle.includes('-pdf-')) {
        // Handle case where -pdf is in the middle (e.g., fuer-dich-pakete-pdf-gutscheinwert)
        originalProductUrl = `${languagePrefix}/products/${currentHandle.replace('-pdf-', '-')}`;
      } else if (currentHandle.includes('_pdf_')) {
        originalProductUrl = `${languagePrefix}/products/${currentHandle.replace(/_pdf_/, '_')}`;
      } else if (currentHandle.includes('-pdf')) {
        // Handle case where -pdf is anywhere (e.g., fuer-dich-pakete-pdf-gutscheinwert)
        originalProductUrl = `${languagePrefix}/products/${currentHandle.replace('-pdf', '')}`;
      } else {
        // Fallback: just remove 'pdf' anywhere
        originalProductUrl = `${languagePrefix}/products/${currentHandle.replace(/pdf/i, '')}`;
      }
      
      console.log("[WUN-25] Generated original URL:", originalProductUrl);
    } else {
      // Current is original, generate PDF URL
      originalProductUrl = currentUrl;
      
      // Simple approach: just append -pdf at the end
      pdfProductUrl = `${languagePrefix}/products/${currentHandle}-pdf`;
      
      console.log("[WUN-25] Generated PDF URL:", pdfProductUrl);
    }

    const result = {
      isCurrentPDF,
      originalProductUrl,
      pdfProductUrl,
      currentHandle,
      productTitle
    };
    
    console.log("[WUN-25] Final product info:", result);
    return result;
  }

  // Check cart and get dominant shipping type
  async function getCartShippingType() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      console.log("[WUN-25] Cart data:", cart);
      
      if (!cart.items || cart.items.length === 0) {
        console.log("[WUN-25] Cart is empty");
        return null;
      }
      
      let pdfCount = 0;
      let karteCount = 0;
      
      cart.items.forEach((item, index) => {
        const versandart = item.properties?._Versandart || 
                          item.properties?.Versandart || 
                          item.properties?.['_Versandart'] ||
                          item.properties?.['Versandart'];
        
        console.log(`[WUN-25] Item ${index} title:`, item.title);
        console.log(`[WUN-25] Item ${index} Versandart:`, versandart);
        
        if (versandart === 'PDF' || item.title.includes('PDF')) {
          pdfCount++;
        } else if (versandart === 'Karte') {
          karteCount++;
        }
      });
      
      console.log(`[WUN-25] Cart summary: PDF=${pdfCount}, Karte=${karteCount}`);
      
      // Return dominant type or last added
      if (pdfCount > 0 && karteCount === 0) {
        return 'PDF';
      } else if (karteCount > 0 && pdfCount === 0) {
        return 'Karte';
      } else if (pdfCount > 0 && karteCount > 0) {
        // Mixed - use localStorage last added
        return localStorage.getItem(`${ID}_last-added-type`) || null;
      }
      
      return null;
    } catch (error) {
      console.error("[WUN-25] Error checking cart:", error);
      return null;
    }
  }

  // Auto-redirect on page load based on cart
  async function autoRedirectBasedOnCart() {
    console.log("[WUN-25] Checking if auto-redirect needed...");
    
    // Check if this is from manual navigation (don't redirect)
    const isManualNav = sessionStorage.getItem(`${ID}_manual-navigation`);
    if (isManualNav) {
      console.log("[WUN-25] Manual navigation detected, skipping auto-redirect");
      sessionStorage.removeItem(`${ID}_manual-navigation`);
      return;
    }
    
    // Check cooldown
    const lastRedirect = sessionStorage.getItem(`${ID}_last-auto-redirect`);
    const now = Date.now();
    if (lastRedirect && (now - parseInt(lastRedirect)) < 2000) {
      console.log("[WUN-25] Redirect cooldown active, skipping");
      return;
    }
    
    // ==========================================
    // NEW: Check if user has manually selected an option
    // If user manually selected a type, respect their choice
    // and don't auto-redirect even if cart is different
    // ==========================================
    const productInfo = getCurrentProductInfo();
    const currentType = productInfo.isCurrentPDF ? 'PDF' : 'Karte';
    
    const userManualOverride = sessionStorage.getItem(`${ID}_user-manual-override`);
    if (userManualOverride) {
      console.log("[WUN-25] ✓ User manual override detected:", userManualOverride);
      console.log("[WUN-25] Current product type:", currentType);
      
      // If user's choice matches current page type, respect it - don't auto-redirect
      if (userManualOverride === currentType) {
        console.log("[WUN-25] ✓ User MANUALLY SELECTED this type - RESPECTING CHOICE, skipping auto-redirect");
        return;
      }
    }
    
    const cartType = await getCartShippingType();
    if (!cartType) {
      console.log("[WUN-25] No cart type detected, skipping auto-redirect");
      return;
    }
    
    console.log("[WUN-25] Cart type:", cartType);
    console.log("[WUN-25] Current product type:", currentType);
    
    // Check if current product has metafield
    const hasMetafield = checkProductMetafield();
    console.log("[WUN-25] Current product has metafield:", hasMetafield);
    
    if (cartType !== currentType) {
      console.log("[WUN-25] TYPE MISMATCH! Need to redirect");
      
      // If cart type is PDF but current product doesn't have metafield (no PDF version), don't redirect
      if (cartType === 'PDF' && !hasMetafield) {
        console.log("[WUN-25] Cart has PDF but current product has no metafield - no PDF version exists");
        console.log("[WUN-25] Staying on current product (original/Karte version)");
        return;
      }
      
      const targetUrl = cartType === 'PDF' ? productInfo.pdfProductUrl : productInfo.originalProductUrl;
      
      if (targetUrl) {
        console.log("[WUN-25] Redirecting to:", targetUrl);
        sessionStorage.setItem(`${ID}_last-auto-redirect`, now.toString());
        sessionStorage.setItem(`${ID}_target-shipping-option`, cartType);
        window.location.href = targetUrl;
      } else {
        console.log("[WUN-25] Target URL not found");
      }
    } else {
      console.log("[WUN-25] Already on correct product type");
    }
  }

  function saveWertstufeSelection() {
    const wertSelect = document.querySelector('select[name="options[Wertstufe]"], select[name="id[Wertstufe]"], .product-form__input select');
    if (wertSelect && wertSelect.value) {
      const selectedId = wertSelect.value;
      
      console.log("[WUN-25] Saving Wertstufe ID:", selectedId);
      sessionStorage.setItem(`${ID}_selected-wertstufe-id`, selectedId);
    }
  }

  function restoreWertstufeSelection() {
    let savedId = sessionStorage.getItem(`${ID}_selected-wertstufe-id`);
    
    if (savedId) {
      const wertSelect = document.querySelector('select[name="options[Wertstufe]"], select[name="id[Wertstufe]"], .product-form__input select');
      
      if (wertSelect) {
        let optionToSelect = Array.from(wertSelect.options).find(opt => opt.value === savedId);
        
        if (optionToSelect) {
          wertSelect.value = optionToSelect.value;
          wertSelect.dispatchEvent(new Event('change', { bubbles: true }));
          console.log("[WUN-25] Restored Wertstufe with ID:", savedId);
        }
      }
    }
  }

  function navigateToProductPage(targetUrl, selectedOption) {
    console.log("[WUN-25] Manual navigation to:", targetUrl);
    
    // Validate URL - accept both /products/ and /en/products/ or /fr/products/ etc
    const isValidUrl = targetUrl && (
      targetUrl.startsWith('/products/') ||
      targetUrl.startsWith('/en/products/') ||
      targetUrl.startsWith('/nl/products/')
    );
    
    if (!isValidUrl) {
      alert("Error: Invalid product URL.");
      console.error("[WUN-25] Invalid URL:", targetUrl);
      return;
    }
    
    saveWertstufeSelection();
    sessionStorage.setItem(`${ID}_target-shipping-option`, selectedOption);
    sessionStorage.setItem(`${ID}_manual-navigation`, 'true');
    
    // Maintain language context - URL might already have language prefix or might not
    let finalUrl = targetUrl;
    const currentPathname = window.location.pathname;
    
    // Check if targetUrl already has language prefix
    const hasLanguagePrefix = targetUrl.startsWith('/en/') || 
                             targetUrl.startsWith('/nl/');
    
    if (!hasLanguagePrefix) {
      // targetUrl doesn't have prefix, check current page and add if needed
      if (currentPathname.includes('/en/')) {
        finalUrl = targetUrl.replace('/products/', '/en/products/');
      } else if (currentPathname.includes('/nl/')) {
        finalUrl = targetUrl.replace('/products/', '/nl/products/');
      }
      // German (default) doesn't need prefix
    }
    // If targetUrl already has language prefix, use it as-is
    
    console.log("[WUN-25] Navigating with language context to:", finalUrl);
    window.location.href = finalUrl;
  }

  async function validateProductUrl(url) {
    try {
      const response = await fetch(`${url}.js`);
      return response.ok;
    } catch (error) {
      return false;
    }
  }

  var handleShippingOptionChange = (selectedShippingOption) => {
    localStorage.setItem(`${ID}_shipping-option`, selectedShippingOption);
    if (q(`.${ID}__shipping-option-input`)) {
      q(`.${ID}__shipping-option-input`).value = selectedShippingOption;
    }
  };

  var setButtonState = () => {
    const productInfo = getCurrentProductInfo();
    let selectedShippingOption;
    
    const targetOption = sessionStorage.getItem(`${ID}_target-shipping-option`);
    if (targetOption) {
      selectedShippingOption = targetOption;
      sessionStorage.removeItem(`${ID}_target-shipping-option`);
    } else {
      selectedShippingOption = productInfo.isCurrentPDF ? 'PDF' : 'Karte';
    }
    
    localStorage.setItem(`${ID}_shipping-option`, selectedShippingOption);
    
    if (q(`.${ID}__shipping-option-input`)) {
      q(`.${ID}__shipping-option-input`).value = selectedShippingOption;
    }
    
    const targetRadio = q(`.${ID}__shipping-option input[value="${selectedShippingOption}"]`);
    if (targetRadio) {
      targetRadio.checked = true;
    }
  };

  var handleCartChange = () => {
    poll(
      () => q(".cart-count-bubble"),
      () => {
        setButtonState();
      }
    );
  };

  var handleClick = () => {
    document.addEventListener("click", ({ target }) => {
      if (target.closest(`.product-form__submit`) && !target.closest(`.WUN-9-btn`)) {
        const currentShipping = localStorage.getItem(`${ID}_shipping-option`);
        if (currentShipping) {
          localStorage.setItem(`${ID}_last-added-type`, currentShipping);
          console.log("[WUN-25] Tracked add to cart:", currentShipping);
        }
        
        handleCartChange();
      } else if (target.closest(`.WUN-9-btn`) || target.closest(`.ptc_button`)) {
        poll(
          () => q(".pplr_atc_form"),
          () => {
            const currentShipping = localStorage.getItem(`${ID}_shipping-option`);
            insert(q(".pplr_atc_form"), "beforeend", `<input class="${ID}__shipping-option-modal-input" type="hidden" name="properties[_Versandart]" value="${currentShipping}">`, q(`.${ID}__shipping-option-modal-input`));
            
            if (currentShipping) {
              localStorage.setItem(`${ID}_last-added-type`, currentShipping);
            }
          },
          true
        );
      }
    });
  };

  var addShippingOptions = () => {
    poll(
      () => q(selectors.productQuantity),
      () => {
        const template = `
        <div class="${ID}__shipping-options-container">
         <div class="${ID}__shipping-options-title">
            <div class="${ID}__shipping-options-title-text">${getTextAsset('shippingMethod')}</div>
            <div class="${ID}__tooltip-container">
               ${infoIcon}
               <div class="${ID}__tooltip-popup">${getTextAsset('tooltipText')}</div>
            </div>
         </div>
         <div class="${ID}__shipping-options">
            
            <div class="${ID}__shipping-option ship1">
             <input type="radio" id="shipping-option-1" name="Versandart" value="Karte">
             <label for="shipping-option-1">
             <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.3333 4.6875H3.33325C3.18407 4.6875 3.04099 4.74676 2.9355 4.85225C2.83002 4.95774 2.77075 5.10082 2.77075 5.25V18C2.77075 18.3481 2.90903 18.6819 3.15517 18.9281C3.40132 19.1742 3.73516 19.3125 4.08325 19.3125H20.5833C20.9313 19.3125 21.2652 19.1742 21.5113 18.9281C21.7575 18.6819 21.8958 18.3481 21.8958 18V5.25C21.8958 5.10082 21.8365 4.95774 21.731 4.85225C21.6255 4.74676 21.4824 4.6875 21.3333 4.6875ZM12.3333 12.7369L4.77888 5.8125H19.8876L12.3333 12.7369ZM9.86481 12L3.89575 17.4713V6.52875L9.86481 12ZM10.6973 12.7631L11.9583 13.9144C12.0619 14.0092 12.1974 14.0619 12.3379 14.0619C12.4785 14.0619 12.6139 14.0092 12.7176 13.9144L13.9739 12.7631L19.8876 18.1875H4.77981L10.6973 12.7631ZM14.8017 12L20.7708 6.52875V17.4713L14.8017 12Z" fill="#3B3B3B"></path></svg>
             <span class="${ID}__shipping-option-text" style="font-weight: bold;"><b>${getTextAsset('giftCardByMail')}</b></span>
             <span class="${ID}__shipping-option-description">
             ${getTextAsset('shippingDays')}
             </span>
             
             </label>
            </div>

             <div class="${ID}__shipping-option ship2">
               <input type="radio" id="shipping-option-2" name="Versandart" value="PDF">
               <label for="shipping-option-2">
               <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.875 14.8125C20.875 14.9617 20.8157 15.1048 20.7102 15.2102C20.6048 15.3157 20.4617 15.375 20.3125 15.375H17.875V17.25H19.5625C19.7117 17.25 19.8548 17.3093 19.9602 17.4148C20.0657 17.5202 20.125 17.6633 20.125 17.8125C20.125 17.9617 20.0657 18.1048 19.9602 18.2102C19.8548 18.3157 19.7117 18.375 19.5625 18.375H17.875V20.0625C17.875 20.2117 17.8157 20.3548 17.7102 20.4602C17.6048 20.5657 17.4617 20.625 17.3125 20.625C17.1633 20.625 17.0202 20.5657 16.9148 20.4602C16.8093 20.3548 16.75 20.2117 16.75 20.0625V14.8125C16.75 14.6633 16.8093 14.5202 16.9148 14.4148C17.0202 14.3093 17.1633 14.25 17.3125 14.25H20.3125C20.4617 14.25 20.6048 14.3093 20.7102 14.4148C20.8157 14.5202 20.875 14.6633 20.875 14.8125ZM8.5 16.6875C8.5 17.334 8.24319 17.954 7.78607 18.4111C7.32895 18.8682 6.70897 19.125 6.0625 19.125H5.125V20.0625C5.125 20.2117 5.06574 20.3548 4.96025 20.4602C4.85476 20.5657 4.71168 20.625 4.5625 20.625C4.41332 20.625 4.27024 20.5657 4.16475 20.4602C4.05926 20.3548 4 20.2117 4 20.0625V14.8125C4 14.6633 4.05926 14.5202 4.16475 14.4148C4.27024 14.3093 4.41332 14.25 4.5625 14.25H6.0625C6.70897 14.25 7.32895 14.5068 7.78607 14.9639C8.24319 15.421 8.5 16.041 8.5 16.6875ZM7.375 16.6875C7.375 16.3394 7.23672 16.0056 6.99058 15.7594C6.74444 15.5133 6.4106 15.375 6.0625 15.375H5.125V18H6.0625C6.4106 18 6.74444 17.8617 6.99058 17.6156C7.23672 17.3694 7.375 17.0356 7.375 16.6875ZM15.25 17.4375C15.25 18.2829 14.9142 19.0936 14.3164 19.6914C13.7186 20.2892 12.9079 20.625 12.0625 20.625H10.5625C10.4133 20.625 10.2702 20.5657 10.1648 20.4602C10.0593 20.3548 10 20.2117 10 20.0625V14.8125C10 14.6633 10.0593 14.5202 10.1648 14.4148C10.2702 14.3093 10.4133 14.25 10.5625 14.25H12.0625C12.9079 14.25 13.7186 14.5858 14.3164 15.1836C14.9142 15.7814 15.25 16.5921 15.25 17.4375ZM14.125 17.4375C14.125 16.8905 13.9077 16.3659 13.5209 15.9791C13.1341 15.5923 12.6095 15.375 12.0625 15.375H11.125V19.5H12.0625C12.6095 19.5 13.1341 19.2827 13.5209 18.8959C13.9077 18.5091 14.125 17.9845 14.125 17.4375ZM4 11.0625V4.3125C4 3.9644 4.13828 3.63056 4.38442 3.38442C4.63056 3.13828 4.9644 3 5.3125 3H14.3125C14.3865 2.99994 14.4598 3.01449 14.5282 3.0428C14.5965 3.07111 14.6586 3.11264 14.7109 3.165L19.9609 8.415C20.0661 8.52054 20.1251 8.6635 20.125 8.8125V11.0625C20.125 11.2117 20.0657 11.3548 19.9602 11.4602C19.8548 11.5657 19.7117 11.625 19.5625 11.625C19.4133 11.625 19.2702 11.5657 19.1648 11.4602C19.0593 11.3548 19 11.2117 19 11.0625V9.375H14.3125C14.1633 9.375 14.0202 9.31574 13.9148 9.21025C13.8093 9.10476 13.75 8.96168 13.75 8.8125V4.125H5.3125C5.26277 4.125 5.21508 4.14475 5.17992 4.17992C5.14475 4.21508 5.125 4.26277 5.125 4.3125V11.0625C5.125 11.2117 5.06574 11.3548 4.96025 11.4602C4.85476 11.5657 4.71168 11.625 4.5625 11.625C4.41332 11.625 4.27024 11.5657 4.16475 11.4602C4.05926 11.3548 4 11.2117 4 11.0625ZM14.875 8.25H18.205L14.875 4.92V8.25Z" fill="#3B3B3B"></path></svg>
               <span class="${ID}__shipping-option-text" style="font-weight: bold;"><b>${getTextAsset('pdfByEmail')}</b></span>
              <span class="${ID}__shipping-option-description">
               ${getTextAsset('instantly')}
               </span>
               </label>
            </div>
          </div>
      </div>`;
        
        try {
          const productInfo = getCurrentProductInfo();
          let selectedShippingOption;
          
          const targetOption = sessionStorage.getItem(`${ID}_target-shipping-option`);
          if (targetOption) {
            selectedShippingOption = targetOption;
            sessionStorage.removeItem(`${ID}_target-shipping-option`);
          } else {
            selectedShippingOption = localStorage.getItem(`${ID}_shipping-option`) || 
                                   (productInfo.isCurrentPDF ? 'PDF' : 'Karte');
          }
         
          insert(q(selectors.productQuantity), "beforebegin", template, q(`.${ID}__shipping-options`));
          insert(
            q(selectors.productForm),
            "beforeend",
            `<input class="${ID}__shipping-option-input" type="hidden" name="properties[_Versandart]" value="${selectedShippingOption}">`,
            q(`.${ID}__shipping-option-input`)
          );
          
          setButtonState();

          // Handle manual shipping option changes
          qq(`.${ID}__shipping-option input`).forEach((input) => {
            input.addEventListener("change", async (e) => {
              const selectedValue = e.target.value;
              const productInfo = getCurrentProductInfo();
              
              console.log("[WUN-25] User changed to:", selectedValue);
              
              // ==========================================
              // NEW: Set flag to track user's manual selection
              // This prevents auto-redirect from overriding user choice
              // ==========================================
              sessionStorage.setItem(`${ID}_user-manual-override`, selectedValue);
              console.log("[WUN-25] ✓ User manual selection recorded:", selectedValue);
              
              const needsNavigation = (selectedValue === 'PDF' && !productInfo.isCurrentPDF) || 
                                    (selectedValue === 'Karte' && productInfo.isCurrentPDF);
              
              if (needsNavigation) {
                let targetUrl = selectedValue === 'PDF' ? productInfo.pdfProductUrl : productInfo.originalProductUrl;
                
                if (targetUrl) {
                  const isValid = await validateProductUrl(targetUrl);
                  if (isValid) {
                    navigateToProductPage(targetUrl, selectedValue);
                  } else {
                    alert(`Oops! Die ${selectedValue === 'PDF' ? 'PDF-Version' : 'Karten-Version'} ist aktuell nicht verfügbar. Wir arbeiten bereits daran - bitte versuche es in Kürze noch einmal oder wende dich an unseren Kundenservice`);
                    const previousOption = selectedValue === 'PDF' ? 'Karte' : 'PDF';
                    q(`.${ID}__shipping-option input[value="${previousOption}"]`).checked = true;
                  }
                } else {
                  alert(`Oops! Die ${selectedValue === 'PDF' ? 'PDF-Version' : 'Karten-Version'} ist aktuell nicht verfügbar. Wir arbeiten bereits daran - bitte versuche es in Kürze noch einmal oder wende dich an unseren Kundenservice`);
                  const previousOption = selectedValue === 'PDF' ? 'Karte' : 'PDF';
                  q(`.${ID}__shipping-option input[value="${previousOption}"]`).checked = true;
                }
              } else {
                handleShippingOptionChange(selectedValue);
                const hiddenInput = q(`.${ID}__shipping-option-input`);
                if (hiddenInput) hiddenInput.value = selectedValue;
              }
            });
          });

        } catch (error) {
          expLog("ERROR INSERTING SHIPPING OPTIONS", error);
        }
      }
    );
  };

  function hideAddonIfPDFCart() {
    if (!location.pathname.includes("/cart")) return;

    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const hasPDF = cart.items.length > 0 && cart.items.every((item) => {
          return item.properties && 
                 (item.properties.Versandart === "PDF" || item.properties["Versandart"] === "PDF");
        });

        if (hasPDF) {
          const addonSection = document.querySelector("#cart-packaging-options-selector");
          if (addonSection) {
            addonSection.style.display = "none";
            const customSection = document.querySelector(".section-template--24093352001864__custom_liquid_8aWrEq-padding");
            if (customSection) customSection.style.display = "none";
          }
        }
      });
  }

  function switchGalleryImage(shippingOption) {
    console.log("[WUN-25] Switching gallery image for:", shippingOption);
    
    const thumbnails = document.querySelectorAll('button[aria-label*="Bild"][aria-label*="in Galerieansicht laden"]');
    
    let targetButton = null;
    
    if (shippingOption === "PDF") {
      targetButton = Array.from(thumbnails).find(btn => 
        btn.getAttribute('aria-label').includes('Bild 4')
      );
    } else {
      targetButton = Array.from(thumbnails).find(btn => 
        btn.getAttribute('aria-label').includes('Bild 1')
      );
    }
    
    if (targetButton) {
      targetButton.click();
    }
  }


  function handleShippingOptionImageSwitch() {
    document.addEventListener("change", function (e) {
      if (e.target.matches(`.${ID}__shipping-option input`)) {
        const selectedValue = e.target.value;
        
        const productInfo = getCurrentProductInfo();
        const needsNavigation = (selectedValue === 'PDF' && !productInfo.isCurrentPDF) || 
                               (selectedValue === 'Karte' && productInfo.isCurrentPDF);
        
        if (!needsNavigation) {
          switchGalleryImage(selectedValue);
        }
        
        const wun9Content = document.querySelector(".WUN-9-content");
        if (wun9Content) {
          wun9Content.style.display = "block";
        }
      }
    });
  }
  
  function mainJS() {
    testInfo("Add selector PDF or Karte to PDP - Styling 40 with Metafield Check");
    injectTooltipStyles();
    
    // STEP 0: Initialize shipping options visibility based on metafield
    initializeShippingOptionsVisibility();
    
    // STEP 1: Check cart and auto-redirect if needed (runs immediately)
    autoRedirectBasedOnCart();
    
    // STEP 2: Add shipping options
    addShippingOptions();
    handleClick();
    hideAddonIfPDFCart();
    handleShippingOptionImageSwitch();
    
    // STEP 3: Restore Wertstufe
    poll(
      () => document.querySelector('select[name="options[Wertstufe]"], select[name="id[Wertstufe]"], .product-form__input select'),
      () => {
        setTimeout(() => {
          restoreWertstufeSelection();
        }, 100);
      }
    );
  
    // STEP 4: Set initial gallery image
    poll(
      () => q(`.${ID}__shipping-option input:checked`),
      () => {
        const checkedOption = q(`.${ID}__shipping-option input:checked`);
        if (checkedOption) {
          switchGalleryImage(checkedOption.value);
        }
      }
    );
  }

  mainJS();
})();

//# sourceURL=ABtest/WUN-25_1.js